import { SaveTwoTone } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Container, Table, Input, Card, Grid, Box } from '@mui/material';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useForm } from 'react-hook-form';
import Footer from 'src/components/Commons/Footer';
import useLanguage from 'src/hooks/Language/useLanguage';
import { useCommonSettings } from 'src/hooks/Settings/CommonSettings/useCommonSettings';
import BreakCrumbs from 'src/pages/Breakcum';
import { TBreadCrumb } from 'src/types/Breakcrumbs/breadcrumb.model';
import { CommonSettings, TCommonSettingsRequest } from 'src/types/Systems/settings.model';
import { PathURL } from 'src/utils/constants/path';

export const Settings = () => {
  const { language } = useLanguage();
  const { mutationUpdateCommonSettings, queryCommonSettings } = useCommonSettings();
  const breadcrumb: TBreadCrumb[] = [
    { path: PathURL.dashboard, name: language.dashboard.titleHeader },
    { path: '', name: language.settingPage.settingTitle }
  ];
  const { register, handleSubmit, reset } = useForm<CommonSettings>({
    mode: 'onSubmit'
  });

  const onSubmit = async (data: any) => {
    const model: TCommonSettingsRequest = {
      commonSettings: data
    };
    await mutationUpdateCommonSettings.mutateAsync(model);
  };
  useEffect(() => {
    if (queryCommonSettings?.data?.data) {
      reset(queryCommonSettings.data.data);
    }
  }, [queryCommonSettings?.data?.data]);
  return (
    <>
      <Helmet>
        <title>{language.teamsPage.teamTitle}</title>
      </Helmet>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Container sx={{ mt: 3 }} maxWidth="xl">
          <Grid container direction="row" justifyContent="center" alignItems="stretch" spacing={3}>
            <Grid item xs={12} md={12}>
              {breadcrumb && <BreakCrumbs breadcrumb={breadcrumb} />}
            </Grid>
          </Grid>
          <Box pb={1} className="flex justify-between	items-center">
            <Box></Box>
            <Box>
              <LoadingButton
                variant="contained"
                loading={mutationUpdateCommonSettings.isLoading}
                color="primary"
                startIcon={<SaveTwoTone />}
                type="submit"
              >
                {language.common.buttons.save}
              </LoadingButton>
            </Box>
          </Box>

          <Grid container className="pt-10">
            <Grid item xs={12}>
              <Card className="p-10">
                <Table>
                  <tbody>
                    <tr>
                      <td>
                        <b>Tỷ lệ hoàn</b>
                      </td>
                      <td>
                        <Input {...register('orderRefundPercent')} type="number" />
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </form>
      <Footer />
    </>
  );
};
